import { Link } from "react-scroll"

import "../styles/Dining.css"
import "../styles/TabBar.css"

import { diningData } from "../data/diningData"

import Banner from "./navigation/Banner"
import NavBar from "./navigation/NavBar"
import DiningItem from "./DiningItem"
import Footer from "./navigation/Footer"

function Dining() {
  const app = diningData.appetizers;
  const delSan = diningData.deliSandwiches;
  const hotSub = diningData.hotSubs;
  const sal = diningData.specialtySalads;
  const cal = diningData.calzones;
  const din = diningData.dinners;
  const piz = diningData.pizzas;

  return (
    <div className="dining-page-container" >
      <Banner />
      <div className="nav-tab-container">
        <NavBar />        
        <div className="tabbar-container" >
          <Link className="tabbar-link" to="apps" smooth={true} offset={-200}>Appetizers</Link>
          <Link className="tabbar-link" to="sandwiches" smooth={true} offset={-200}>Deli Sandwiches</Link>
          <Link className="tabbar-link" to="subs" smooth={true} offset={-200}>Hot Subs</Link>
          <Link className="tabbar-link" to="salads" smooth={true} offset={-200}>Salads</Link>
          <Link className="tabbar-link" to="calzones" smooth={true} offset={-200}>Calzones</Link>
          <Link className="tabbar-link" to="dinners" smooth={true} offset={-200}>Dinners</Link>
          <Link className="tabbar-link" to="pizzas" smooth={true} offset={-200}>Pizzas</Link>
        </div>
      </div>

      <div className="dining-page-content-container">
        <div className="dining-content-1">
          <h1>Dining</h1>
        </div>

        <div className="dining-content-2">
          <div className="dining-section-header" id="apps">
            <span>Appetizers</span>
          </div>
          <div className="dining-section-container">
            {app.map(item => (
              <DiningItem props={item} key={item.id} />
            ))}
          </div>       

          <div className="dining-section-header" id="sandwiches">
            <span>Deli Sandwiches</span>
          </div>
          <div className="dining-section-container">
            {delSan.map(item => (
              <DiningItem props={item} key={item.id} />
            ))}     
          </div>  
          
          <div className="dining-section-header" id="subs">
            <span>Hot Subs</span>
          </div>
          <div className="dining-section-container">
            {hotSub.map(item => (
              <DiningItem props={item} key={item.id} />
            ))}
          </div>

          <div className="dining-section-header" id="salads">
            <span>Specialty Salads</span>
          </div>
          <div className="dining-section-container">
            {sal.map(item => (
              <DiningItem props={item} key={item.id} />
            ))}
          </div>

          <div className="dining-section-header" id="calzones">
            <span>Calzones</span>
          </div>
          <div className="dining-section-container">
            {cal.map(item => (
              <DiningItem props={item} key={item.id} />
            ))}
          </div>

          <div className="dining-section-header" id="dinners">
            <span>Dinners</span>
          </div>
          <div className="dining-section-container">
            {din.map(item => (
              <DiningItem props={item} key={item.id} />
            ))}
          </div>

          <div className="dining-section-header" id="pizzas">
            <span>Brick Oven Pizzas</span><br/>
            <span className="subnote">*Gluten free available</span><br/>
            <span className="subnote">*For half/half pizza, please specify in details</span>
          </div>
          <div className="dining-section-container">
            {piz.map(item => (
              <DiningItem props={item} key={item.id} />
            ))}
          </div>
        </div>

        <Footer />
        
      </div>
    </div>
  )
}

export default Dining
